<template>
  <div class="relative px-6 py-3 pb-6 text-dark-type-4">
    <div class>

      <div class="mx-auto my-4 w-full">
        <img class="mx-auto" src="@/assets/img/bus_traffic_light.svg">
      </div>
      <div class="mx-auto my-4 font-bold text-center text-dark-type-3">
        {{ title || 'This route is currently not available' }}
      </div>
      <div>
        <div v-html="content">
        </div>
      </div>
    </div>
    <button
        @click="close()"
        class="block w-full h-12 py-4 mt-8 mb-3 font-medium text-sm
        text-center text-black rounded focus:outline-none bg-active">
      Dismiss
    </button>

  </div>

</template>

<script>
export default {
  name: "route-availability",
  props: {
    title: {type: String},
    content: {type: String}
  },
  data() {
    return {
      customerNotificationSuccess: false,
      loading: false
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}

</style>